import { render, staticRenderFns } from "./checkup.vue?vue&type=template&id=74a50f6b&scoped=true"
import script from "./checkup.vue?vue&type=script&lang=js"
export * from "./checkup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a50f6b",
  null
  
)

export default component.exports